// CREATE COMMON_PROPERTY FOR PROPERTY PAGE
export const CREATE_COMMON_PROPERTY_REQUEST = 'CREATE_COMMON_PROPERTY_REQUEST';
export const CREATE_COMMON_PROPERTY_SUCCESS = 'CREATE_COMMON_PROPERTY_SUCCESS';
export const CREATE_COMMON_PROPERTY_FAILURE = 'CREATE_COMMON_PROPERTY_FAILURE';

// CREATE COMMON_PROPERTY FOR PROPERTY PAGE
export const CREATE_COMMON_STYLE_REQUEST = 'CREATE_COMMON_STYLE_REQUEST';
export const CREATE_COMMON_STYLE_SUCCESS = 'CREATE_COMMON_STYLE_SUCCESS';
export const CREATE_COMMON_STYLE_FAILURE = 'CREATE_COMMON_STYLE_FAILURE';

// CREATE COMMON_PROPERTY FOR PROPERTY PAGE
export const CREATE_COMMON_FORMAT_REQUEST = 'CREATE_COMMON_FORMAT_REQUEST';
export const CREATE_COMMON_FORMAT_SUCCESS = 'CREATE_COMMON_FORMAT_SUCCESS';
export const CREATE_COMMON_FORMAT_FAILURE = 'CREATE_COMMON_FORMAT_FAILURE';

export const FETCH_COMMON_PROPERTY_BY_ID_REQUEST = 'FETCH_COMMON_PROPERTY_BY_ID_REQUEST';
export const FETCH_COMMON_PROPERTY_BY_ID_SUCCESS = 'FETCH_COMMON_PROPERTY_BY_ID_SUCCESS';
export const FETCH_COMMON_PROPERTY_BY_ID_FAILURE = 'FETCH_COMMON_PROPERTY_BY_ID_FAILURE';

export const FETCH_ANY_COMMON_PROPERTY_BY_ID_REQUEST = 'FETCH_ANY_COMMON_PROPERTY_BY_ID_REQUEST';
export const FETCH_ANY_COMMON_PROPERTY_BY_ID_SUCCESS = 'FETCH_ANY_COMMON_PROPERTY_BY_ID_SUCCESS';
export const FETCH_ANY_COMMON_PROPERTY_BY_ID_FAILURE = 'FETCH_ANY_COMMON_PROPERTY_BY_ID_FAILURE';
// CREATE COMMON_FEEDBACK
export const CREATE_COMMON_FEEDBACK_REQUEST = 'CREATE_COMMON_FEEDBACK_REQUEST';
export const CREATE_COMMON_FEEDBACK_SUCCESS = 'CREATE_COMMON_FEEDBACK_SUCCESS';
export const CREATE_COMMON_FEEDBACK_FAILURE = 'CREATE_COMMON_FEEDBACK_FAILURE';

export const SET_SINGLE_ROW_CLICK_ID = 'SET_SINGLE_ROW_CLICK_ID';
export const RESET_SINGLE_ROW_CLICK_ID = 'RESET_SINGLE_ROW_CLICK_ID';

export const CREATE_USER_FORM_COMMON_PROPERTY = 'CREATE_USER_FORM_COMMON_PROPERTY';
export const CREATE_USER_FORM_COMMON_STYLE = 'CREATE_USER_FORM_COMMON_STYLE';
export const CREATE_USER_FORM_COMMON_FORMAT = 'CREATE_USER_FORM_COMMON_FORMAT';
export const COMMON_PROPERTY_USERFORM_RESET = 'COMMON_PROPERTY_USERFORM_RESET';
export const COMMON_STYLE_USERFORM_RESET = 'COMMON_STYLE_USERFORM_RESET';
export const COMMON_FORMAT_USERFORM_RESET = 'COMMON_FORMAT_USERFORM_RESET';

export const CREATE_COMMON_FEEDBACK_FORM = 'CREATE_COMMON_FEEDBACK_FORM';
export const COMMON_FEEDBACK_USERFORM_RESET = 'COMMON_FEEDBACK_USERFORM_RESET';

export const COMMON_APPROVALMAIL_USERFORM = 'COMMON_APPROVALMAIL_USERFORM ';

export const APP_LOGOUT_REQUEST = 'APP_LOGOUT_REQUEST';
export const APP_LOGOUT_SUCCESS = 'APP_LOGOUT_SUCCESS';
export const APP_LOGOUT_FAILURE = 'APP_LOGOUT_FAILURE';

export const APP_FORCE_LOGOUT_REQUEST = 'APP_FORCE_LOGOUT_REQUEST';
export const APP_FORCE_LOGOUT_SUCCESS = 'APP_FORCE_LOGOUT_SUCCESS';
export const APP_FORCE_LOGOUT_FAILURE = 'APP_FORCE_LOGOUT_FAILURE';

export const SET_FORCE_LOGOUT_VAR = 'SET_FORCE_LOGOUT_VAR';
